import React from 'react';

const QuickLinks = () => {
	return (
		<section className="quick-links-section">
			<h5>QuickLinks</h5>
			<ul className="quick-links-list">
				<li>
					<a href="/">Shipping information</a>
				</li>
				<li>
					<a href="/">Returns & Exchange</a>
				</li>
				<li>
					<a href="/">Terms & Conditions</a>
				</li>
				<li>
					<a href="/">Privacy Policy</a>
				</li>
			</ul>
		</section>
	);
};

export default QuickLinks;
